import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {MembersList} from "../components/members/MembersList";
import SingleMemberDetails from "../components/members/SingleMemberDetails";

const Members = () => {
    const members = useSelector((state) => state.organisation?.currentOrganisation?.members);
    const campaigns = useSelector((state) => state.organisation?.currentOrganisation?.campaigns);
    const integrations = useSelector((state) => state.organisation?.currentOrganisation?.integrations);

    const [currentMemberId, setCurrentMemberId] = useState(null);

    const onMemberClick = (member) => {
        setCurrentMemberId(member?._id || null);
    }

    const onMemberClose = () => {
        setCurrentMemberId(null);
    }

    const currentMember = currentMemberId
        ? members?.find((m) => m._id === currentMemberId) || null
        : null;

    return (
        <div className="main-section">
            {currentMember ? <SingleMemberDetails campaigns={campaigns} integrations={integrations} member={currentMember} onMemberClose={onMemberClose}/> : <MembersList onMemberClick={onMemberClick} members={members}/>}
        </div>
    );
};

export default Members;
